import { render, staticRenderFns } from "./SecondaryNavigationBar.vue?vue&type=template&id=28e309b9"
import script from "./SecondaryNavigationBar.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports